export default __webpack_public_path__ + "static/media/15.2f688ce9.png";